export enum Parking {
  Open,
  Closed,
  Entrance_Gate,
  Covered,
  Possibility,
  Basement,
}
